// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".callout--x3R0u{display:flex;align-items:center;border-radius:4px;background-color:#fff;padding:12px 16px;margin-bottom:1rem;gap:16px;overflow:clip}.callout-content--Us4pQ{flex:1;min-width:0;display:flex;flex-direction:column;gap:4px}.callout-title--xkYsY{font-weight:600;margin-bottom:0;font-size:14px;line-height:20px;letter-spacing:.14px;color:#24282f}.callout-text--o1Ko9{margin-bottom:0;font-size:14px;line-height:20px;letter-spacing:.28px;color:#24282f}.callout-promo--pRW4v{background-color:#eeecfe;border:none}.callout-upsell--H6cw_{border:1px solid #b4bccd}.callout-info--QGa96{background-color:#f0f0f4;border:none}.callout-error--YzyUL{background-color:#feeef2;border:none}.callout-alert--al7gd{background-color:#fff3cb;border:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"callout": "callout--x3R0u",
	"callout-content": "callout-content--Us4pQ",
	"callout-title": "callout-title--xkYsY",
	"callout-text": "callout-text--o1Ko9",
	"callout-promo": "callout-promo--pRW4v",
	"callout-upsell": "callout-upsell--H6cw_",
	"callout-info": "callout-info--QGa96",
	"callout-error": "callout-error--YzyUL",
	"callout-alert": "callout-alert--al7gd"
};
export default ___CSS_LOADER_EXPORT___;
